import React from 'react';
import { useIntl } from 'react-intl';
import RichText from '../../UI/RichText';
import Button from '../../UI/Button/Button';

import {
  Banner,
  ImageContainer,
  DesktopPromoImage,
  TabletPromoImage,
  MobilePromoImage,
  ContentContainer,
  CopyContainer,
  CtaContainer,
} from './styles';

interface Props {
  data: Record<string, any>;
  className: string;
  section: string;
}

const BannerCard = ({ data, className, section }: Props) => {
  const { locale } = useIntl();
  const {
    bannerType,
    foregroundImageDesktop,
    foregroundImageTablet,
    foregroundImageMobile,
    bannerDisplayText,
    bannerCta,
  } = data;

  return (
    <Banner className={`${bannerType} ${className}`}>
      {foregroundImageDesktop && (
        <ImageContainer className={className}>
          <DesktopPromoImage
            image={foregroundImageDesktop}
            aria-label={foregroundImageDesktop.altText}
            alt=""
          />
          <TabletPromoImage
            image={foregroundImageTablet || foregroundImageDesktop}
            isImageDecorative
          />
          <MobilePromoImage
            image={
              foregroundImageMobile
              || foregroundImageTablet
              || foregroundImageDesktop
            }
            isImageDecorative
          />
        </ImageContainer>
      )}
      {!className.includes('hero-carousel')
        && (bannerDisplayText || bannerCta) && (
          <ContentContainer className={`${bannerType} ${className}`}>
            {bannerDisplayText && (
              <CopyContainer>
                <RichText document={bannerDisplayText.heading} />
              </CopyContainer>
            )}
            {bannerCta && (
              <CtaContainer className={`${bannerType} ${className}`}>
                <Button
                  buttonText={bannerCta.ctaLabel.ctaLabel}
                  buttonColour={bannerCta.ctaColor}
                  buttonSize="small"
                  url={bannerCta.ctaUrl}
                  route={bannerCta.ctaTarget}
                  locale={locale}
                  ariaLabel={bannerCta.ctaAriaLabel}
                  data-section={section}
                  data-cta-id={`${foregroundImageDesktop.altText} - ${bannerCta.ctaLabel.ctaLabel}`}
                />
              </CtaContainer>
            )}
          </ContentContainer>
      )}
    </Banner>
  );
};

export default BannerCard;
